import {InviteToolsResponse, TenderPhaseType, TenderSelection} from '@frontend/shared-api';
import {TenderPhaseUtils} from './tender-phase.util';
import {TenderStatusUtils} from './tender-status.util';

export class TenderPhaseCompletionUtils {
  public static canCompletePhase(
    response: InviteToolsResponse,
    phase: TenderPhaseType,
    today: Date,
  ): boolean {
    return (
      this.isSubmissionDeadlinePassed(response, today) ||
      this.areAllParticipantsFinal(response, phase)
    );
  }

  private static isSubmissionDeadlinePassed(response: InviteToolsResponse, today: Date): boolean {
    const {initialSubPhase, extendedSubPhase, finalSubPhase} = response.currentPhase;
    const submissionDate = (finalSubPhase ?? extendedSubPhase ?? initialSubPhase)?.submissionDate;

    return !!submissionDate && this.toIsoDate(today) > submissionDate;
  }

  private static areAllParticipantsFinal(
    response: InviteToolsResponse,
    phase: TenderPhaseType,
  ): boolean {
    return response.tools.every((tool) => {
      const {selection, status} = TenderPhaseUtils.getApiResponseFieldValues(tool, phase);
      return selection !== TenderSelection.PARTICIPANT || TenderStatusUtils.isFinalStatus(status);
    });
  }

  private static toIsoDate(date: Date): string {
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${date.getFullYear()}-${month}-${day}`;
  }
}
